import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCornerRadius: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCornerRadius"><Path d="M21 3V5H5V21H3V3H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCornerRadius;
